import type { Track } from "../../api/types";
import { OptionTile } from "../../components/OptionTile";
import { ScreenHeader } from "../../components/ScreenHeader";

interface PickTrackScreenProps {
  tracks: { key: Track; label: string }[];
  busy: boolean;
  onPick: (track: Track) => void;
}

export function PickTrackScreen({ tracks, busy, onPick }: PickTrackScreenProps) {
  return (
    <div>
      <ScreenHeader
        kicker="Before Step 1"
        title="Which skill are you building toward?"
        sub="This sets the platforms, examples and standards we hold your work to. Choose the skill you want to earn from. You can't change it later."
      />
      <div className="flex flex-col gap-2.5">
        {tracks.map((track, index) => (
          <OptionTile
            key={track.key}
            selected={false}
            disabled={busy}
            marker={index + 1}
            onToggle={() => onPick(track.key)}
            title={track.label}
            detail="Your samples, practice jobs and Gig Board match this track"
          />
        ))}
      </div>
    </div>
  );
}
